<style scoped lang="scss" type="text/scss">
    .shadow-placeholder {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .7);
        display: flex;
        justify-content: center;
        align-items: center;
        transition: all .2s;
        color: #CCC;

        &.circular {
            border-radius: 50%;
        }
    }
</style>

<template>
    <div class="shadow-placeholder" :class="{'circular': circular}">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: '',
        props: {
            circular: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {};
        }
    };
</script>
